import { AbstractModel } from '../abstract.model';
import { MenuItem } from './menu-item';
import { PosButton } from './pos-button';

export interface MenuSectionData {
  name: string;
  displayName?: string;
  menuItemIds: string[];
  menuItems?: MenuItem[];
  posButton?: PosButton;
}

export class MenuSection extends AbstractModel<MenuSectionData> {
  constructor(public data: MenuSectionData) {
    super(data);
  }
}
